import Meta from '../../assets/companies/meta.svg';
import Google from '../../assets/companies/google.svg';
import Netflix from '../../assets/companies/netflix.svg';
import PnG from '../../assets/companies/pg.svg';
import Paypal from '../../assets/companies/paypal.svg';
import Payoneer from '../../assets/companies/payoneer.svg';
import SandboxMeta from '../../assets/sandboxCompanies/meta.svg';
import SandboxGoogle from '../../assets/sandboxCompanies/google.svg';
import SandboxNetflix from '../../assets/sandboxCompanies/netflix.svg';
import SandboxPnG from '../../assets/sandboxCompanies/pg.svg';
import SandboxPaypal from '../../assets/sandboxCompanies/paypal.svg';
import SandboxPayoneer from '../../assets/sandboxCompanies/payoneer.svg';

export const COMPANIES_WHO_TRUST = [
    {
        src: Meta,
        alt: 'Trusted by Meta',
    },
    {
        src: Google,
        alt: 'Trusted by Google',
    },
    {
        src: Netflix,
        alt: 'Trusted by Netflix',
    },
    {
        src: PnG,
        alt: 'Trusted by PnG',
    },
    {
        src: Paypal,
        alt: 'Trusted by Paypal',
    },
    {
        src: Payoneer,
        alt: 'Trusted by Payoneer',
    },
];

export const SANDBOX_COMPANIES_WHO_TRUST = [
    {
        src: SandboxMeta,
        alt: 'Trusted by Meta',
    },
    {
        src: SandboxGoogle,
        alt: 'Trusted by Google',
    },
    {
        src: SandboxNetflix,
        alt: 'Trusted by Netflix',
    },
    {
        src: SandboxPnG,
        alt: 'Trusted by PnG',
    },
    {
        src: SandboxPaypal,
        alt: 'Trusted by Paypal',
    },
    {
        src: SandboxPayoneer,
        alt: 'Trusted by Payoneer',
    },
];
